import { service } from '../../../../helpers/http' 

export const ActionGetCustomerContacts = ({ dispatch }, payload) => { 
    return service({
        module: 'customerContact',
        action: 'getCustomerContacts',
        payload: payload
    })
}

export const ActionPostCustomerContacts = ({ dispatch }, payload) => {

    return service({
        module: 'customerContact',
        action: 'postCustomerContacts',
        payload: payload
    })
    
}

export const ActionPutCustomerContacts = ({ dispatch }, payload) => {

    return service({
        module: 'customerContact',
        action: 'putCustomerContacts',
        payload: payload
    })
    
}

export const ActionDeleteCustomerContacts = ({ dispatch }, payload) => {

    return service({
        module: 'customerContact',
        action: 'deleteCustomerContacts',
        payload: payload
    })
    
}